import React from 'react'
import { ButtonGroup } from "react-bootstrap";
import Login from "../../Auth/Login";
import Logo from "./../Logo";
import Register from "../../Auth/Register";
import { isMobile, Event, BRAND } from "../../../../Helper";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileView: isMobile()
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobileView: isMobile() });
    }

    collapse = () => {
        Event.emit('toggle_sidebar', true);
    }

    desktop = () => {
        const { t } = this.props;
        return (
            <div className="topbar-premium" id={'topbar'}>
                <Logo brand={BRAND} />
                <nav className="navbar-custom ml-auto">
                    <ul className="list-unstyled topbar-nav mb-0">
                        <li className="guest-dropdown">
                            <Login t={t} />
                        </li>
                        <li className="guest-dropdown ml-2">
                            <Register t={t} />
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }

    mobile = () => {
        const { t } = this.props;
        return (
            <div className="topbar-premium" id={'topbar'}>
                <Logo brand={BRAND} />
                <nav className="navbar-custom ml-auto">
                    <ul className="list-unstyled topbar-nav mb-0">
                        <li className="guest-dropdown">
                            <Login t={t} />
                        </li>
                        <li className="guest-dropdown ml-1">
                            <Register t={t} />
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }

    render() {
        return this.state.isMobileView ? this.mobile() : this.desktop();
    }
}

export default Header;